import {
    ApolloClient
} from 'apollo-client'

import {
    InMemoryCache,
    defaultDataIdFromObject
} from 'apollo-cache-inmemory'

import {
    setContext
} from 'apollo-link-context'

import {
    HttpLink
} from 'apollo-link-http'

import {
    withClientState
} from 'apollo-link-state'

import {
    onError
} from 'apollo-link-error'

import {
    ApolloLink
} from 'apollo-link'

import defaultState from './defaultState'

const cache = new InMemoryCache({
    dataIdFromObject: (object) => {
        switch (object.__typename) {
            case 'Translation':
                return `${object.__typename}:${object.key} (${object.locale})`
            default:
                return defaultDataIdFromObject(object)
        }
    }
}).restore({})

const withToken = setContext((_, previousContext) => {
    let token = localStorage.getItem('jwt')

    return {
        ...previousContext,
        headers: {
            ...(previousContext && previousContext.headers),
            authorization: token ? `Bearer ${token}` : ''
        }
    }
})

// TODO: Detect correctly when the API reutrned a permission error token
//   automatically remove the token from localStorage
//
// const resetToken = onError(({ graphQLErrors }) => {
//   if (graphQLErrors && _.some(graphQLErrors, (e) => e.extensions && e.extensions.forbidden)) {
//     localStorage.removeItem('jwt')
//   }
// })

const logErrors = onError(({ graphQLErrors, networkError, operation }) => {
    if (graphQLErrors) {
        graphQLErrors.map(({ message, locations, path }) => {}
            // tslint:disable-next-line
            /*     console.log(
                    '[GraphQL error]: Message: ',
                    message,
                    ', Location: ',
                    locations,
                    ', Path: ',
                    path,
                    ', Operation name: ',
                    operation.operationName
                ) */
        )
    }
    if (networkError) {
        // tslint:disable-next-line
        console.log(`
      [Network error]: ${networkError},
      Operation name: ${operation.operationName}
    `);
    }
})

const apolloLinkState = withClientState({
    cache,
    defaults: defaultState,
    resolvers: { Query: {}, Mutation: {} }
})

const apolloHttpLink = new HttpLink({
    uri: 'https://atlasbackend.imaflora.org/graphql'
        // uri: "http://localhost:8300/graphql"

})

const client = new ApolloClient({
    cache,
    defaultOptions: {
        query: {
            errorPolicy: 'all'
        },
        mutate: {
            errorPolicy: 'all',
            fetchPolicy: 'no-cache'
        }
    },
    link: ApolloLink.from([
        withToken,
        // TODO: See above TODO
        // resetToken,
        logErrors,
        apolloLinkState,
        apolloHttpLink
    ])
})

window.__APOLLO_CLIENT__ = client
export default client


// WEBPACK FOOTER //
// ./src/services/ApolloClient/ApolloClient.js